import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { serverRoleOnlineDuration } from "@/api/dataAll/onlineDuration";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import * as echarts from "echarts";
export default {
  name: "serverRoleOnlineTime",
  mixins: [tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      more: true,
      value2: [],
      tableData: [],
      dates: [],
      datas: [],
      series: [],
      Dynamic: [],
      selectedArr: {},
      isServer: false,
      serverLists: [],
      customTime: [{
        label: this.$t('customOnlineDurationFilter'),
        value: '1'
      }],
      characterList: [{
        label: this.$t('characterSword'),
        value: 1
      }, {
        label: this.$t('characterThunder'),
        value: 2
      }, {
        label: this.$t('characterIce'),
        value: 3
      }]
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    levelChange: function levelChange(e) {
      if (!e) {
        this.paramsData.recharge_levels = '';
      }
    },
    searchClicknew: function searchClicknew() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var queue, dates, datesList, i, _list, list, _i, qd;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.paramsData.server_id.length == 0)) {
                  _context.next = 3;
                  break;
                }

                _this.$message.error(_this.$t('pleaseSelectServer'));

                return _context.abrupt("return");

              case 3:
                _this.reqLoading = true;
                queue = [];
                dates = _this.$times.getDayAll(_this.value2[0], _this.value2[1]);
                datesList = [];

                for (i = 0; i < dates.length; i += 10) {
                  _list = dates.slice(i, i + 10);
                  datesList.push({
                    starttime: _list[0],
                    endtime: _list[_list.length - 1]
                  });
                }

                list = [];
                _i = 0;

              case 10:
                if (!(_i < datesList.length)) {
                  _context.next = 18;
                  break;
                }

                _context.next = 13;
                return serverRoleOnlineDuration(_objectSpread(_objectSpread({}, datesList[_i]), _this.paramsData));

              case 13:
                qd = _context.sent;

                if (qd.status == 200) {
                  list.push(qd);

                  _this.searchClick(list);
                }

              case 15:
                _i++;
                _context.next = 10;
                break;

              case 18:
                _this.reqLoading = false;

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClick: function searchClick(res) {
      var _this2 = this;

      var newDatas = {
        data: {},
        date: []
      };
      res.forEach(function (i) {
        newDatas.data = _objectSpread(_objectSpread({}, newDatas.data), i.data.data);
        newDatas.date = [].concat(_toConsumableArray(newDatas.date), _toConsumableArray(i.data.date));
      });
      var newData = JSON.parse(JSON.stringify(newDatas.data));
      this.dates = [];
      this.datas = [];
      this.series = [];
      var columns = [{
        label: this.$t('gameDuration'),
        prop: 'length'
      }];
      var data = [];
      var num = 0;
      var knum = 0;
      var allLength = 0;

      for (var i in newData) {
        for (var j in newData[i]) {
          if (j != 'role_avg_minutes') {
            this.datas.push(j);
          }

          data.push({
            length: j == 'role_avg_minutes' ? this.$t('avgOnlineMinutes') : j
          });
        }

        allLength = Object.keys(newData[i]).length;
        break;
      }

      for (var _i2 in newData) {
        this.dates.push(_i2);
        num += 1;
        columns.push({
          label: _i2,
          prop: num + 'Number'
        });
        var obj = {
          name: _i2,
          type: "bar",
          data: [],
          smooth: true
        };

        for (var k in newData[_i2]) {
          knum += 1;
          data[knum - 1][num + 'Number'] = newData[_i2][k];
          obj.data.push(newData[_i2][k]);

          if (knum == allLength) {
            knum = 0;
          }
        }

        this.series.push(obj);
      }

      this.tableData = data;
      this.Dynamic = columns;
      this.getechart();
      this.$nextTick(function () {
        _this2.getTableRight();
      });
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("onlineDurationEchart");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        title: {
          text: this.$t('accountOnlineDurationHours')
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        legend: {
          data: this.dates,
          // 这里显示点击搜索的日期--图表的最上面
          width: '80%' // selected: this.selectedArr,

        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: this.datas
        },
        yAxis: {
          type: "value"
        },
        series: this.series
      };
      option && myChart.setOption(option, true);
    },
    exportdata: function exportdata() {
      this.$export.excel({
        columns: this.Dynamic,
        data: this.tableData,
        title: this.$route.meta.title
      });
    }
  }
};